'use strict';

export default class OPLLoadMore {
    constructor() {
        this.loadMoreButtons = document.querySelectorAll('[data-opl-loadmore]');
    }

    init() {
        this.initLoadMoreButtons();
    }

    initLoadMoreButtons() {
        const self = this;

        if (self.loadMoreButtons) {
            self.loadMoreButtons.forEach(loadMoreButton => {
                const config = JSON.parse(loadMoreButton.dataset.oplLoadmore);

                const listingWrapper = document.getElementById(config.listingWrapper);
                const nodeAliasPath = config.nodeAliasPath;
                const pageSize = config.pageSize;
                const apiUrl = config.apiUrl;
                const additionalParams = loadMoreButton.dataset.oplLoadmoreAdditionalParams ? JSON.parse(loadMoreButton.dataset.oplLoadmoreAdditionalParams) : {};

                loadMoreButton.addEventListener('click', () => {
                    const currentPage = loadMoreButton.dataset.oplLoadmoreCurrent;
                    const pageToFetch = parseInt(currentPage) + 1;

                    if (listingWrapper && nodeAliasPath && pageSize && currentPage) {
                        const paramsString = new URLSearchParams({
                            path: nodeAliasPath,
                            pageSize: parseInt(pageSize),
                            pageNumber: pageToFetch,
                            ...additionalParams
                        }).toString();

                        loadMoreButton.setAttribute('disabled', '');
                        loadMoreButton.classList.add('opl-loader-button');

                        fetch(apiUrl + '?' + paramsString)
                            .then(response => {
                                return response.json();
                            })
                            .then(result => {
                                if (result.object && result.partialAsString) {
                                    // Are there more pages?
                                    if (pageToFetch === result.object.totalPages) {
                                        // No more pages, hide the load more button.
                                        loadMoreButton.style.display = 'none';
                                    }
                                    else {
                                        loadMoreButton.dataset.oplLoadmoreCurrent = pageToFetch;
                                    }

                                    listingWrapper.innerHTML += result.partialAsString
                                }
                            })
                            .catch(error => {
                                console.log(error);
                            })
                            .finally(() => {
                                loadMoreButton.removeAttribute('disabled');
                                loadMoreButton.classList.remove('opl-loader-button');
                            });
                    }
                });
            });
        }
    }
}
